import { combineReducers } from 'redux';
import { login } from './login';

export const auth =  combineReducers({
  login
})